export enum ToastType {
  ERROR = 'error',
  INFO = 'info',
  SUCCESS ='success',
  WARNING = 'warning'
}
